import { App } from 'vue'
import LanguageSelector from './LanguageSelector.vue'
import UserBar from './UserBar.vue'
import SimpleBreadcrumbs from './SimpleBreadcrumbs.vue'
import SellerCard from './SellerCard.vue'
import BuyerCard from './BuyerCard.vue'
import OutletCard from './OutletCard.vue'
import PublicationCard from './PublicationCard.vue'
const register = (app: App<Element>): void => {
  app
  .component('UserBar', UserBar)
  .component('SimpleBreadcrumbs', SimpleBreadcrumbs)
  .component('SellerCard', SellerCard)
  .component('BuyerCard', BuyerCard)
  .component('OutletCard', OutletCard)
  .component('LanguageSelector', LanguageSelector)
  .component('PublicationCard', PublicationCard)
}

export default {
  register,
}
